<ng-template #template>
    <div
      class="card-spacing"
      [ngClass]="[
        'col-lg-' + width,
        needpaddingLeft ? 'pr-lg-0' : 'p-lg-0',
        isZoom ? 'zoomed' : ''
      ]"
    >
      <div class="card h-100" [ngClass]="{ 'card-comb-left': width === 8 }">
        <div class="card-body">
          <!--<h2>Region 1</h2>-->
          <h2>{{ data?.title }}</h2>
          <div style="display: block">
            {{ data?.description }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  